import script from "./Availability.vue?vue&type=script&setup=true&lang=js"
export * from "./Availability.vue?vue&type=script&setup=true&lang=js"

import "./Availability.vue?vue&type=style&index=0&id=c475841a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2842137582/src/pineridgefarmsapartments/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c475841a"]])

export default __exports__